import { render, staticRenderFns } from "./AdminNmeaField.vue?vue&type=template&id=aba2756c"
import script from "./AdminNmeaField.vue?vue&type=script&lang=ts"
export * from "./AdminNmeaField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports